import { jsx as a } from "react/jsx-runtime";
import { Hint as m } from "@systemeio/ui";
import { useTranslation as r } from "./i18n.mjs";
import { TipTapEditor as f } from "./tip-tap.mjs";
import { EditorExtensionEnum as o } from "./enums/editor-extensions-enum.mjs";
import { FontFamilyEnum as x } from "./extensions/font-family-extension/utils.mjs";
const E = (t) => {
  var i, e, l;
  const { t: n } = r();
  return /* @__PURE__ */ a(
    f,
    {
      defaultFont: x.Arial,
      ...t,
      extensionOption: {
        ...t.extensionOption,
        [o.TextColor]: {
          ...(i = t.extensionOption) == null ? void 0 : i[o.TextColor],
          showAlpha: !1
        },
        [o.TextBackgroundColor]: {
          ...(e = t.extensionOption) == null ? void 0 : e[o.TextBackgroundColor],
          showAlpha: !1
        },
        [o.FontFamily]: {
          ...(l = t.extensionOption) == null ? void 0 : l[o.FontFamily],
          noFontFamilyElement: /* @__PURE__ */ a(m, { label: n("font_family.mailbox_default_hint"), children: n("font_family.mailbox_default") })
        }
      }
    }
  );
};
export {
  E as TipTapEmailEditor
};
